
<script>
import { Bar } from "vue-chartjs";

export default {
  name: "DifotBarChart",
  extends: Bar,
  props: ['monthlabels', 'chartmonth'],
  mounted() {
    this.renderChart(
      {
        labels: this.monthlabels,
        datasets: [
          {
            label: this.chartmonth[0].label,
            backgroundColor: this.chartmonth[0].backgroundColor,
            data: this.chartmonth[0].data,
            borderWidth: this.chartmonth[0].borderWidth
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
</script>
